import { PROJECTS_DEFAULT_QUERY_PARAMS } from "@/components";
import DashboardTablePreview from "@/components/Dashboard/DashboardTablePreview";
import { SmallerNameCol } from "@/components/ProjectsTable/styled";
import { pendingIntakeApprovalsFieldNames as fieldNames } from "@/enums";
import { routes } from "@/helpers";
import { useColumnFactory } from "@/hooks";
import { useGetPendingApprovalsQuery } from "@/services";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";
import { DateParam, useQueryParams } from "use-query-params";

const PendingIntakeApprovalsPreview = () => {
  const intl = useIntl();
  const [queryParams, setQueryParams] = useQueryParams({
    ...PROJECTS_DEFAULT_QUERY_PARAMS,
    estimatedLaunchDate: DateParam,
  });

  const { createIntakeViewLinkColumn } = useColumnFactory(
    queryParams,
    setQueryParams
  );

  const {
    data: { data: projectIntakesPendingApproval, totalCount } = {},
    isFetching,
  } = useGetPendingApprovalsQuery({ ...queryParams, pageSize: 5 });

  return (
    <DashboardTablePreview
      data={projectIntakesPendingApproval}
      isFetching={isFetching}
      title={intl.formatMessage({
        id: "dashboard.titles.pendingIntakeApprovals",
      })}
      titleRoute={routes.dashboardFullViews.pendingIntakeApprovals}
      totalCount={totalCount}
      columns={[
        createIntakeViewLinkColumn(
          intl.formatMessage({ id: "dashboard.columns.intake" }),
          intl.formatMessage({ id: "dashboard.columns.approve" })
        ),
        {
          title: intl.formatMessage({ id: "dashboard.columns.projectNumber" }),
          dataIndex: fieldNames.projectNumber,
          width: 80,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.projectName" }),
          render: ({ projectName, secureProject }) => (
            <SmallerNameCol>
              {secureProject && (
                <Tooltip
                  title={intl.formatMessage({ id: "project.isSecureMessage" })}
                  trigger={["hover"]}
                >
                  <FontAwesomeIcon icon={faLock} className="mr-2" />
                </Tooltip>
              )}
              {projectName}
            </SmallerNameCol>
          ),
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.type" }),
          dataIndex: fieldNames.projectTypeLabel,
        },
        {
          title: intl.formatMessage({
            id: "dashboard.columns.financeApprovalGroup",
          }),
          dataIndex: fieldNames.financeApprovalGroupLabel,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.approver" }),
          dataIndex: fieldNames.approverName,
        },
        {
          title: intl.formatMessage({ id: "dashboard.columns.days" }),
          dataIndex: fieldNames.daysAvailable,
        },
      ]}
    />
  );
};

export default PendingIntakeApprovalsPreview;
